export default function getProductName(hotelsInfo, deal) {
  if (deal.selectedDepartureId === null) {
    return hotelsInfo.map(({ name }) => name).toString();
  }

  return deal.value.name;
}
